import Chart from 'chart.js'
import { Scatter, generateChart } from 'vue-chartjs'
import { Delaunay } from 'd3-delaunay'
import defaultTo from 'lodash/defaultTo'
import { getBackgroundColor } from '../../../../util/colors'

Chart.defaults.voronoi = Chart.defaults.scatter
Chart.defaults.voronoi.elements = {
  ...Chart.defaults.voronoi.elements,
  point: {
    borderColor: 'rgba(0,0,0,0)',
    borderWidth: 1,
    backgroundColor: 'rgba(0,0,0,0)',
    hitRadius: 50
  }
}

const voronoiController = Chart.controllers.scatter.extend({
  // Initializes the controller
  initialize: function (chart, datasetIndex) {
    // Call super method first
    Chart.controllers.scatter.prototype.initialize.call(this, chart, datasetIndex)

    const n = chart.config.data.datasets[datasetIndex].data.length
    this.colors = Array.from({ length: n }, () => Math.random())
  },

  draw: function (ease) {
    const meta = this.getMeta()
    const context = this.chart.chart.ctx
    const height = this.chart.height
    const width = this.chart.width

    const particles = meta.data.map(pt => [pt._view.x, pt._view.y])
    const colors = this.chart.data.datasets[0].data.map(pt => getBackgroundColor(pt.val))

    const delaunay = Delaunay.from(particles)
    const voronoi = delaunay.voronoi([0.5, 0.5, width - 0.5, height - 0.5])

    context.save()
    context.clearRect(0, 0, width, height)

    context.beginPath()
    voronoi.render(context)
    voronoi.renderBounds(context)
    context.strokeStyle = '#000'
    context.stroke()

    if (particles.length > 0) {
      let finalGradient = []

      const gradient = [
        [255, 0, 0],
        [255, 192, 0],
        [250, 243, 0],
        [153, 255, 51],
        [0, 152, 0]
      ]

      for (let i = 0; i < gradient.length - 1; i++) {
        const steps = particles.length - 1
        let current = gradient[i]
        let target = gradient[i + 1]

        finalGradient.push(gradient[i])

        let stepping = [
          (gradient[i + 1][0] - gradient[i][0]) / steps,
          (gradient[i + 1][1] - gradient[i][1]) / steps,
          (gradient[i + 1][2] - gradient[i][2]) / steps
        ]

        for (let i = 0; i < steps; i++) {
          current = [
            current[0] + stepping[0],
            current[1] + stepping[1],
            current[2] + stepping[2]
          ]

          const normalized = [
            Math.floor(current[0]),
            Math.floor(current[1]),
            Math.floor(current[2])
          ]
          finalGradient.push(normalized)
        }
      }

      for (let i = 0; i < particles.length; i++) {
        const rgb = finalGradient[Math.floor(this.colors[i] * finalGradient.length)]
        const color = defaultTo(colors[i], `rgb(${rgb[0]}, ${rgb[1]}, ${rgb[2]})`)
        context.beginPath(),
          voronoi.renderCell(i, context),
          (context.fillStyle = color),
          (context.fillOpacity = .25),
          context.fill()
      }
    }

    context.fillStyle = '#000'

    context.beginPath()
    delaunay.renderPoints(context)
    context.fill()

    context.restore()

    // Call super method
    Chart.controllers.scatter.prototype.draw.call(this, ease)
  }
})

Chart.controllers.voronoi = voronoiController

const VoronoiChart = generateChart('voronoi-chart', 'voronoi')

export default VoronoiChart
